export default __webpack_public_path__ + "static/media/carolyn-testimonial.7ee84a4c.png";